/**
 * @file isElementPositionEqual
 * @author yuzong(yuzong@tencent.com)
 */
export function isElementPositionEqual(a, b) {
  return a.top === b.top && a.bottom === b.bottom && a.left === b.left && a.right === b.right;
}